<template>
  <div class="container py-5">

    <div class="buttons">
      <router-link
        :to="{ name: 'SampleRequestMaker' }"
        class="button is-primary">
        Add a Sample Request
      </router-link>
      <a class="button"
        v-if="selected.length > 0"
        @click="launchConfirmDelete()">
        <span class="icon is-medium">
          <i class="fas fa-trash has-text-danger"></i>
        </span>
        <span>Delete {{ selected.length }} Selected Sample Requests</span>
      </a>
    </div>

    <div class="tabs mt-0">
      <ul>
        <li 
          v-for="reason in requestReasons"
          :key="reason"
          @click="setFilter({
            field: 'request_reason', 
            value: reason
          })"
          :class="{ 'is-active': filters.request_reason == reason }">
          <a>{{ reason }} Requests</a>
        </li>
      </ul>
    </div>

    <article 
      v-if="!loading && requests.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        There are no sample requests.
      </div>
    </article>

    <v-fade-transition v-else mode="out-in">
      <table 
        :key="filters.request_reason" 
        class="table is-fullwidth is-hoverable is-clickable has-small-font">

        <thead>
          <tr>
            <th>
              <v-checkbox 
                :value="allSelected" 
                @input="toggleAllSelected($event)"/>
            </th>
            <th 
              v-for="(header, headerIndex) in headers"
              :key="headerIndex">
              {{ header }}
            </th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr
            class="v-centered"
            v-for="request in requests"
            :key="request.id"
            @click="viewRequest(request)">

            <td>
              <v-checkbox 
                @click.native.stop=""
                :value="selected.indexOf(request.id) != -1"
                @input="toggleSelected(request.id)"/>
            </td>
            <td>
              {{ request.request_reason }}
            </td>
            <td v-if="filters.request_reason == 'Project'">
              {{ request.sample ? request.sample.project ? 
                request.sample.project.project_name : '' : '' }}
            </td>
            <td>
              <div>{{ request.requested_by && request.requested_by.display_name }}</div>
              <div class="has-text-grey text--nowrap help">
                {{ format(parse(request.created_on)) }}
              </div>
            </td>
            <td>
              <div 
                v-if="request.sample && request.sample.product_master"
                class="flex flex--row flex--align-center">
                <img 
                  class="mr-2"
                  width="30px"
                  height="auto"
                  v-if="request.sample.product_master.image"
                  :alt="request.sample.product_master.name"
                  :src="request.sample.product_master.image"/>
                <div class="is-size-7">
                  {{ request.sample.product_master.name }}
                </div>
              </div>
              <div 
                class="has-text-grey help" 
                v-if="request.sample && request.sample.product_master">
                {{ request.sample.color }} 
                <span v-if="request.sample.color && request.sample.pattern">-</span> 
                {{ request.sample.pattern }}
              </div>
              <div 
                class="flex flex--row flex--align-center"
                v-if="request.sample && request.sample.image">
                <!-- <img 
                  class="mr-2"
                  width="30px"
                  height="30px"
                  v-if="request.sample.image"
                  :alt="request.sample.image"
                  :src="request.sample.image"/> -->
                <strong class="has-text-grey help">
                  Customization needed
                </strong>
              </div>
            </td>
            <td>
              {{ requestStatus(request) }}
            </td>
            <td>
              <span 
                class="has-text-grey text--nowrap"
                v-if="request.expected_date_needed">
                {{ format(parse(request.expected_date_needed)) }}
              </span>
              <span v-else class="has-text-grey-lighter">No Expected By Date</span>
            </td>
            <td>
              <span 
                class="has-text-grey text--nowrap"
                v-if="request.ready_to_be_sent_date">
                {{ format(parse(request.ready_to_be_sent_date)) }}
              </span>
              <span v-else class="has-text-grey-lighter">Sample not Ready</span>
            </td>
            <td>
              <span 
                class="has-text-grey text--nowrap"
                v-if="request.shipped_date">
                {{ format(parse(request.shipped_date)) }}
              </span>
              <span v-else class="has-text-grey-lighter">Not yet shipped</span>
            </td>
            <td>
              <span 
                class="has-text-grey text--nowrap"
                v-if="request.returned_date">
                {{ format(parse(request.returned_date)) }}
              </span>
              <span v-else class="has-text-grey-lighter">No yet returned</span>
            </td>

            <td>
              <div class="buttons buttons-right">
                <button 
                  @click.stop="launchConfirmDelete(request.id)"
                  class="button is-small has-text-grey">
                  <span class="icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </button>
              </div>
            </td>

          </tr>
        </tbody>

      </table>
    </v-fade-transition>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/>
    
    <!-- <v-datepicker-modal
      v-model="deliveryDatepicker.status"
      :date="deliveryDatepicker.date"
      :title="deliveryDatepicker.title"
      @change="update({ delivered_on: $event.toISOString() })"/>

    <v-datepicker-modal
      v-model="followUpDatepicker.status"
      :date="followUpDatepicker.date"
      :title="followUpDatepicker.title"
      @change="update({ fup_reminder_date: $event.toISOString() })"/> -->

  </div>
</template>

<script>
import VCheckbox from '@/components/base/VCheckbox'
import VConfirmModal from '@/components/base/VConfirmModal'
import VPagination from '@/components/base/VPagination'
import VFadeTransition from '@/components/transitions/VFadeTransition'

import { mapState, mapActions, mapMutations } from 'vuex'
import { parseISO, format } from 'date-fns'

export default {
  components: { 
    VCheckbox,
    // VStyledCheckbox,
    VConfirmModal, 
    VPagination,
    VFadeTransition
    // VDatepickerModal
  },
  data() {
    return {
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this sample request?',
        type: 'danger'
      },
      deleteCb: null,
      parse: (d) => {
        return d ? parseISO(d) : null
      },
      format: (d) => {
        return d ? format(d, 'yyyy-MM-dd HH:mm') : null
      }
    }
  },
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("sampleRequests", [
      "requests", "pagination", "selected", "loading", "allSelected",
      "requestReasons", "filters"
    ]),
    headers({ filters }) {
      return filters.request_reason == 'Project' ? [
        'Request Reason', 'Project', 'Requested By/ On', 'Sample Details', 'Status',
        'Expected By', 'Ready To Be Shipped', 'Shipped On', 'Returned On'
      ] : [
        'Request Reason', 'Requested By/ On', 'Sample Details', 'Status',
        'Expected By', 'Ready To Be Shipped', 'Shipped On', 'Returned On'
      ]
    }
  },
  watch: {
    'pagination.page'() {
      let params = {...this.pagination, ...this.filters}
      this.getRequests(params);
    },
    filters: {
      handler(filters) {
        this.getRequests(filters);
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("sampleRequests", [
      "getRequests", "updateRequest", "deleteRequest", 
      "toggleAllSelected"
    ]),
    ...mapMutations("sampleRequests", [
      "changePage", "toggleSelected", "setFilter"
    ]),
    initialize() {
      this.getRequests(this.filters);
    },
    requestStatus(request) {
      if (request.needs_nda && !request.attachment) {
        return 'NDA needed'
      } else if (!request.ready_to_be_sent) {
        return 'Preparing Sample'
      } else if (!request.is_shipped) {
        return 'Ready to Ship'
      } else if (!request.is_returned) {
        return 'Shipped'
      } else if (request.is_returned) {
        return 'Returned'
      } else {
        return 'N/A'
      }
    },
    update(request) {
      this.updateRequest({ 
        requestId: request.id, 
        data: request
      });
    },
    viewRequest(request) {
      this.$router.push({
        name: 'SampleRequestViewer',
        params: {
          requestId: request.id,
          request: request
        }
      })
    },
    launchConfirmDelete(id) {
      if (!id) {
        this.deleteConfirmedCb = () => {
          this.selected.forEach(id => {
            this.deleteRequest(id);
            this.confirmDelete.state = false;
          })
        }
        this.confirmDelete.message = `Are you sure you want to delete the ${this.selected.length} sample requests?`;
        this.confirmDelete.state = true;
      } else {
        this.deleteConfirmedCb = () => {
          this.deleteRequest(id);
          this.confirmDelete.state = false;
        }
        this.confirmDelete.message = 'Are you sure you want to delete this sample request?';
        this.confirmDelete.state = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>